import request from '@/assets/js/request'
import Qs from 'qs'

//店铺信息
export function getShopInfo(data) {
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/web_shop_info',
		method: 'post',
		data
	})
}


//商品
export function getProductList(data) {
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/product/web_product_list',
		method: 'post',
		data
	})
}
export function getProductInfo(data) {
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/product/web_product_info',
		method: 'post',
		data
	})
}

export function getVipTypeInfo(data) {
	data = Qs.stringify(data);
	return request({
		url: '/webapi/vip_code/vip_type_info',
		method: 'post',
		data
	})
}


//微信登录和用户信息
export function wxLogin(data){
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/web_wx_login',
		method: 'post',
		data
	})
}
export function wxLogout(data){
	if(!data) {
		data = {};
	}
	data['islogin'] = 1;
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/web_wx_logout',
		method: 'post',
		data
	})
}


export function wxUserInfo(data){
	if(!data) {
		data = {};
	}
	data['islogin'] = 1;
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/web_wx_userinfo',
		method: 'post',
		data
	})
}

export function wxRedirectUrl(data){
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/wx_redirect_url',
		method: 'post',
		data
	})
}

export function wxJSAPIConfig(data){
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/get_wx_jsapi_config',
		method: 'post',
		data
	})
}


//创建订单和订单详情 订单列表 重新支付订单
export function CreateShopOrder(data){
	if(!data) {
		data = {};
	}
	data['islogin'] = 1;
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/order/web_order_create',
		method: 'post',
		data
	})
}

export function reloadPayOrder(data){
	if(!data) {
		data = {};
	}
	data['islogin'] = 1;
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/order/web_order_pay',
		method: 'post',
		data
	})
}

export function reloadPayOrderVipCode(data){
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/order/web_order_vip_code_pay',
		method: 'post',
		data
	})
}

export function getOrderInfo(data){
	if(!data) {
		data = {};
	}
	data['islogin'] = 1;
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/order/web_order_info',
		method: 'post',
		data
	})
}
export function getOrderList(data){
	if(!data) {
		data = {};
	}
	data['islogin'] = 1;
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/order/web_order_list',
		method: 'post',
		data
	})
}

export function getOrderVipCodeInfo(data){
	if(!data) {
		data = {};
	}
	data['islogin'] = 1;
	data = Qs.stringify(data);
	return request({
		url: '/webapi/shop/order/web_order_vipcode_info',
		method: 'post',
		data
	})
}





// WEBPACK FOOTER //
// ./src/assets/js/api.js